import { RadioProps, Radio, styled, Theme, IconButton } from '@mui/material';
import { lighten, alpha } from '@mui/material/styles';

const Icon = styled(IconButton)(() => ({
  borderRadius: '50%',
  width: 16,
  height: 16,
  backgroundColor: 'transparent',
}));

const CheckedIcon = styled(IconButton)(() => ({
  boxShadow: 'inherit',
  borderRadius: '50%',
  width: 16,
  height: 16,
  backgroundColor: 'transparent',
  '&:before': {
    display: 'block',
    width: 16,
    height: 16,
    content: '""',
  },
}));

export function RadioButton(props: RadioProps & { color?: string; hasError?: boolean }) {
  return (
    <Radio
      sx={{
        '&.Mui-disabled.Mui-checked > span': {},
      }}
      checkedIcon={
        <CheckedIcon
          sx={{
            backgroundColor: 'background.secondary',
            backgroundImage: ({ palette }: Theme) =>
              `radial-gradient(${palette.icon.main},${palette.icon.main} 20%,transparent 32%)`,
          }}
        />
      }
      icon={
        <Icon
          sx={{
            boxShadow: (theme: Theme) => {
              if (props?.hasError) {
                // Lighten and soften the error ring for better contrast hierarchy
                const lightErr = lighten(theme.palette.other.error, 0.35); // 35% lighter
                return `inset 0 0 0 2px ${alpha(lightErr, 0.9)}`;
              }
              return `inset 0 0 0 2px ${theme.palette.text.main}4D`;
            },
          }}
        />
      }
      {...props}
    />
  );
}
